import React, { useState, useCallback, useMemo } from 'react';
import {
  SwipeableDrawer,
  List,
  ListItemText,
  IconButton,
  useMediaQuery,
  useTheme,
  ListItemButton,
} from '@mui/material';

import * as Icon from 'react-feather';
import { Link } from 'gatsby';
import { globalMenus, Menu } from 'models/menu';

interface Props {
  onChange?: (state: boolean) => void;
  onClickMenu?: (menu: Menu) => void;
}
const DrawerMenu = ({ onClickMenu, onChange }: Props) => {
  const [open, setOpen] = useState(false);
  const { breakpoints, palette, spacing, typography } = useTheme();
  const matches = useMediaQuery(breakpoints.up('lg'));
  const iconSize = useMemo(() => (matches ? 30 : 20), [matches]);

  const handleClick = useCallback(() => {
    setOpen(state => !state);
    onChange?.(true);
  }, [setOpen, onChange]);

  return (
    <>
      <IconButton onClick={handleClick} aria-label="menu">
        <Icon.Menu strokeWidth={1} size={iconSize} />
      </IconButton>
      <SwipeableDrawer
        open={open}
        onClose={() => {
          setOpen(false);
          onChange?.(false);
        }}
        onOpen={() => {
          setOpen(true);
          onChange?.(true);
        }}
      >
        <List
          sx={{
            margin: `${spacing(2)} ${spacing(1)} ${spacing(1)}`,
            minWidth: 250,
            '& a': {
              textDecoration: 'none',
              color: palette.text.primary,
            },
            '& a span': {
              fontSize: typography.body2.fontSize,
            },
          }}
        >
          {globalMenus.map(menu => (
            <li key={menu.path}>
              <Link key={menu.path} to={menu.path} onClick={() => onClickMenu?.(menu)}>
                <ListItemButton key={menu.path}>
                  <ListItemText>{menu.name}</ListItemText>
                </ListItemButton>
              </Link>
            </li>
          ))}
        </List>
      </SwipeableDrawer>
    </>
  );
};

export default DrawerMenu;
